import axios from 'axios';
import Pusher, { Channel, ChannelAuthorizationCallback, Options } from 'pusher-js';

import config from '@app/config/app';

const { pusher: pusherConfig } = config;

const authorizer = (channel: Channel) => ({
  authorize: async (socketId: string, callback: ChannelAuthorizationCallback) => {
    try {
      const response = await axios.post(
        pusherConfig.authEndpoint as string,
        {
          socket_id: socketId,
          channel_name: channel.name,
        },
        {
          withCredentials: true,
        },
      );
      callback(null, response.data);
    } catch (err: any) {
      callback(new Error('Unauthorized'), { auth: '' });
    }
  },
});

const customAuthorizer = authorizer as any as Options['authorizer'];

let instance: Pusher | undefined;
const initialize = () => {
  if (instance) {
    instance.disconnect();
  }

  instance = new Pusher(pusherConfig.key as string, {
    cluster: pusherConfig.cluster as string,
    authEndpoint: pusherConfig.authEndpoint,
    authorizer: customAuthorizer,
  });
  return instance;
};

const getInstance = () => {
  if (!instance) {
    return initialize();
  }
  return instance;
};

const clearInstance = () => {
  if (instance) {
    instance.disconnect();
    instance = undefined;
  }
  return instance;
};

export default {
  initialize,
  getInstance,
  clearInstance,
};
